<template>
  <div>
    <key-value-table
      :items="tableItems"
    />

    <section>
      <header class="has-text-weight-semibold">Guide</header>
      <p>
        {{ data.guides | nullToDash }}
      </p>
    </section>

    <section>
      <header class="has-text-weight-semibold">Waste disposal</header>
      <p>
        {{ data.waste_disposal | nullToDash }}
      </p>
    </section>
  </div>
</template>

<script>
import KeyValueTable from '@/components/structures/KeyValueTable'

export default {
  name: '',
  components: {
    KeyValueTable
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    tableItems () {
      return [
        { label: 'Manufacturer', value: this.data.manufacturer },
        { label: 'Effective time', value: this.data.effective_time },
      ]
    }
  }
}
</script>

<style>

</style>
